import {css, cx}  from "emotion";
import * as React from "react";
import {Types}    from "@Common/types";

import "./tiles-view-config.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {viewModes} from "./view-modes";

export const rTilesViewConfig = ({
    value,
    onChange
}:Types.Common.React.UseState.UseStateNext<string>) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div
            className="tiles-view-config-9du"
        >
            {viewModes.map((vm, i) => (
                <div
                    key={i}
                    className={cx("icon", {active: value === viewModes[i].name}, css`
                        &.active {
                          background: ${themeScheme.xpresso.menuBackgroundColorShadow};
                        }
                    `)}
                    onClick={() => onChange(vm.name)}
                >
                    {vm.icon({fill: value === viewModes[i].name ? "white" : themeScheme.xpresso.menuBackgroundColorShadow})}
                </div>
            ))}
        </div>
    )
);
